(function () {
	'use strict';
	angular.module(modules.homeModule)
		.controller('activityGridViewModalController', controller);

	controller.$inject = ['$http', '$uibModalInstance', '$uibModal', '$filter', 'pubSub', 'npDialog', 'model'];
	function controller($http, $uibModalInstance, $modal, $filter, pubSub, npDialog, model) {
		var vm = this;
		vm.initialize = initialize;
		vm.cancel = cancel;
		vm.tabSettings = [];
		vm.translation = resources;
		function initialize() {
			vm.activityDetail = angular.copy(model.data);
			vm.activityDetail.activityDocuments = vm.activityDetail.activityDocuments || [];
			vm.activityDetail.activityDocuments.forEach(x => {
				const href = `document/${x.documentId}`;
				x.documentName = buildAtag(href, x.documentName, "_blank");
				x.documentId = buildAtag(href, x.documentId, "_blank");
			});
			buildGridTabSetting();
			buildGridSetting();
			vm.dialogHeader = vm.activityDetail.activity ? vm.activityDetail.activity.name : vm.activityDetail.name;
		}

		function buildGridTabSetting() {
			const gridSetting = [
				{
					name: resources.L.Common.documents,
					description: '',
					href: 'activityDocuments', icon: 'fa fa-file-alt ',
					hide: vm.activityDetail.activityDocuments.length === 0,
				},
			];
			const item = gridSetting.find(x => !x.hide);
			if (item) {
				item.active = true;
			}
			vm.tabSettings = gridSetting.filter(x => !x.hide).map((x, index) => {
				x.tabIndex = index + 1;
				return x;
			});
		}

		function buildAtag(href, value, target) {
			if (target)
				return String.format('<a class="link-item" href="{0}" target="{2}">{1}</a>', href, value, target);
			return String.format('<a class="link-item" href="{0}">{1}</a>', href, value);
		}

		function buildGridSetting() {
			vm.activityDocumentsGridSetting = [
				{
					id: 'documentId', name: resources.L.Common.ID, width: 20, coldefault: true
				},
				{
					id: 'documentName', name: resources.L.Common.title, width: 80, coldefault: true
				}
			];
        }



		function cancel() {
			$uibModalInstance.dismiss('cancel');
        }
	}
})();